import { checkLinkPermissionValidity } from '@/components/layouts/Sidebar/Sidebar';
import { SidebarLinkConditional } from '@/types/Sidebar';
import { NAV_ROUTES } from '@/utils/constants';
import {
  BriefcaseBusiness,
  Building,
  Settings,
  Cable,
  ChartColumn,
  Gauge,
  Telescope,
} from 'lucide-react';

export function getTopSidebarLinks(isDataforSeo: boolean): SidebarLinkConditional[] {
  return [
    // {
    //   activeIcon: KeywordsListWhiteIcon,
    //   inactiveIcon: KeywordsListIcon,
    //   altIconText: 'keywords management page icon',
    //   to: `/workspace/${workspaceId}`,
    //   text: 'keywords management',
    // },
    // {
    //   activeIcon: TagsListWhiteIcon,
    //   inactiveIcon: TagsListIcon,
    //   altIconText: 'tags management page icon',
    //   to: `/workspace/${workspaceId}/manage-tags`,
    //   text: 'tags management',
    // },
    {
      icon: Cable,
      altIconText: 'connectors page icon',
      to: NAV_ROUTES.connectors,
      text: 'connectors',
      permission: 'viewer',
      permissiontType: 'workspace',
    },
    {
      icon: ChartColumn,
      altIconText: 'connectors page icon',
      to: NAV_ROUTES.dashboards,
      text: 'dashboards',
      permission: 'viewer',
      permissiontType: 'workspace',
      sublinks: [
        {
          additionalTo: NAV_ROUTES.dashboards,
          icon: Gauge,
          altIconText: 'connectors page icon',
          to: `/dashboards/general`,
          text: 'General',
          permission: 'viewer',
          permissiontType: 'workspace',
        },
        {
          icon: Telescope,
          altIconText: 'connectors page icon',
          to: NAV_ROUTES.dashboard('organicsearch'),
          text: 'Dataforseo',
          permission: 'viewer',
          permissiontType: 'workspace',
          // neededSubscriptionTier: 'essentials',
          customRule() {
            return !isDataforSeo;
          },
        },
      ],
    },
  ];
}

export function getBottomSidebarLinks(
  workspaceId: string,
  isSelectedOrganization: boolean,
): SidebarLinkConditional[] {
  const bottomLinks: SidebarLinkConditional[] = [];
  const sublinks: SidebarLinkConditional[] = [];

  sublinks.push({
    icon: Building,
    altIconText: 'workspace settings page icon',
    to: NAV_ROUTES.organizationSettings,
    text: 'organization settings',
    permission: 'viewer',
    permissiontType: 'organization',
    disabled: !isSelectedOrganization,
  });

  sublinks.push({
    icon: BriefcaseBusiness,
    altIconText: 'workspace settings page icon',
    to: NAV_ROUTES.workspaceSettings,
    text: 'workspace settings',
    permission: 'viewer',
    permissiontType: 'workspace',
    disabled: !workspaceId,
  });

  bottomLinks.push({
    icon: Settings,
    altIconText: 'Settings',
    to: NAV_ROUTES.workspaceSettings,
    text: 'settings',
    isDropdownMode: true,
    sublinks,
    permission: 'viewer',
    permissiontType: 'organization',
  });

  return bottomLinks;
}

export function getSidebarUrlsMapFunction(
  func: ReturnType<typeof checkLinkPermissionValidity>,
) {
  return function (link: SidebarLinkConditional) {
    const { permissionGranted, isSubscriptionValid } = func(link);
    if (permissionGranted && !link.disabled) {
      return link;
    } else {
      const modifiedLink = { ...link, disabled: true };

      if (!isSubscriptionValid) {
        modifiedLink.originalLink = link.to;
        modifiedLink.to = '/wrong-subscription-tier';
      } else {
        modifiedLink.originalLink = link.to;
        modifiedLink.to = '/missing-permissions';
      }
      return modifiedLink;
    }
  };
}
